import { motion } from 'framer-motion';
import React, { ChangeEvent, useState, useEffect } from 'react';
import { Stack } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import logoGov from '../../../assets/logo_govbr.svg';
import logo_sisaf from '../../../assets/logo_sisaf.png';
import ouImg from '../../../assets/ou.jpg';
import Button from '../../../components/Button';
import ContainerBase from '../../../components/ContainerBase';
import Input from '../../../components/InputNew';
import Toast from '../../../components/Toast';
import httpClient from '../../../services/httpClient';
import { swal, swalAtualizacao } from '../../../utils/swal';

// Estilos usando styled-components
const Container = styled.div`
  display: grid;
  grid-template-rows: 7% 30% 18% 45%;
  align-self: center;
  width: 40%;
  height: 84%;
  margin: 0 auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
`;

const IconLogoContainer = styled.div`
  display: grid;
  grid-template-columns: 46% 54%;
  width: 100%;
  align-items: end;
  justify-content: center;

  a {
    display: flex;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.botaoLaranja};
    font-size: 12px;
    margin-left: 2rem;
  }
  img {
    height: 2.5vh;
    max-height: 50px;
    width: auto;
  }
`;

const LogoSistema = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  img {
    height: 20vh;
    width: auto;
  }
`;

const TextContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-top: 2rem;
    margin-bottom: 0.2rem;
    font: normal normal bold 1.35rem Rawline;
  }

  span {
    max-width: 70%;
    font: normal normal normal 1.15rem Rawline;
    letter-spacing: 0px;
    color: #333333;
    opacity: 1;
  }
`;

const SuccessMessageContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  color: #1351b4;
`;

function ResetSenha() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token'); // Obtém o token da URL
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>('');
  const [showSuccess] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  // Verificar se o token está presente
  // useEffect(() => {}, [token, navigate]);

  // Função para atualizar os valores do formulário
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Função genérica de validação de senha
  const validaSenha = (
    password: string,
    confirmPassword: string,
  ): string | null => {
    if (password.length < 6)
      return 'A senha deve conter no mínimo 6 caracteres.';
    if (password !== confirmPassword)
      return 'As senhas digitadas não são iguais.';
    return null;
  };

  const handleSubmit = async () => {
    const { newPassword, confirmPassword } = formData;

    // Validação da nova senha
    const validationError = validaSenha(newPassword, confirmPassword);
    if (validationError) {
      setToastMessage(validationError);
      setShowToast(true);
      return;
    }

    try {
      setIsSubmitting(true);

      // Checar se o token está presente antes de enviar a requisição

      // Enviar a requisição para a API
      const response = await httpClient.post(`/api/auth/reset-password`, {
        token: token,
        novaSenha: newPassword,
      });

      // Verificar a resposta da API
      if (response.status === 201) {
        swalAtualizacao('Sucesso', response.data.message);
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        swal('error', 'Erro!', 'Erro ao redefinir a senha. Tente novamente.');
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Erro ao redefinir a senha. Tente novamente.';
      swal('error', 'Erro!', errorMessage);
    }
  };

  const toggleShowToast = () => setShowToast((prev) => !prev);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <ContainerBase>
        <Toast
          show={showToast}
          onClose={toggleShowToast}
          mensagem={toastMessage}
        />
        <Container>
          <IconLogoContainer>
            <a href="/">
              <span className="material-icons">arrow_back</span>
            </a>
            <img src={logoGov} alt="Logo do SisAF" />
          </IconLogoContainer>
          <LogoSistema>
            <img src={logo_sisaf} alt="Logo do SisAF" />
          </LogoSistema>
          <TextContainer>
            <p style={{ color: '#1351B4' }}>Redefinir Senha</p>
            <span>Informe sua nova senha:</span>
          </TextContainer>
          <Stack
            className="gap-2"
            style={{ width: '41%', margin: '18px auto' }}
          >
            <Input
              type={'password'}
              value={formData.newPassword}
              onChange={handleChange}
              id={'newPassword'}
              placeholder={'Nova Senha'}
              textAlign="center"
              name={'newPassword'}
            />
            <Input
              type={'password'}
              value={formData.confirmPassword}
              onChange={handleChange}
              id={'confirmPassword'}
              placeholder={'Confirme a Nova Senha'}
              textAlign="center"
              name={'confirmPassword'}
            />
            <div className="d-grid mt-3 gap-3">
              <Button
                botaoAzul
                label={'Redefinir Senha'}
                onClick={handleSubmit}
                disabled={isSubmitting} // Desativa o botão enquanto processa
              />
              <img
                src={ouImg}
                alt="Ou"
                style={{
                  display: 'flex',
                  maxWidth: '30%',
                  margin: '0 auto',
                }}
              />
              <Button
                botaoAmarelo
                label={'Retornar ao Login'}
                onClick={() => navigate('/')}
              />
            </div>
          </Stack>
          {showSuccess && (
            <SuccessMessageContainer>
              <p>Senha alterada com sucesso!</p>
            </SuccessMessageContainer>
          )}
        </Container>
      </ContainerBase>
    </motion.div>
  );
}

export default ResetSenha;
